export const colors = [
    '#12B76A',
    '#0BA5EC',
    '#667085',
    '#FB6514',
    '#F04438',
    '#F79009',
    '#EE46BC',
    '#7A5AF8',
    '#A3A3A3',
    '#000',
    '#FACC15',
    '#4ADE80',
    '#3B82F6',
    '#9333EA',
    '#E11D48',
    '#14B8A6',
    '#F43F5E',
    '#F97316',
    '#9CA3AF',
    '#16A34A',
    '#F59E0B',
    '#2563EB',
    '#C026D3',
    '#DB2777',
    '#0D9488',
    '#C2410C',
    '#8B5CF6',
    '#22D3EE',
    '#FF9F1C',
    '#2EC4B6',
    '#E71D36',
    '#FF3366',
    '#8FBCBB',
    '#B48EAD',
    '#5E81AC',
    '#D97706',
    '#059669',
    '#10B981',
    '#1E40AF',
    '#BE185D',
    '#6D28D9',
    '#FDE047',
    '#7C3AED',
    '#047857',
    '#CA8A04',
    '#EA580C',
    '#4C1D95',
    '#DC6803',
    '#F43F5E',
    '#0EA5E9',
    '#F4A261',
    '#264653',
    '#2A9D8F',
    '#E76F51'
]
